import React from 'react'
import Select from '@/Shared/Form/Select';
import { useFormContext, useWatch } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { countries } from 'countries-list';
import Input from '@/Shared/Form/Input';
import { isEUandEEACountryCodes, supervisoryAuthority } from '@/lib/settings';

const SupervisoryAuthority = () => {
  const { formState: { errors }, control, setValue } = useFormContext();
  const options = Object.keys(countries).map(country => ({
    ...countries[country],
    code: country,
  }));
  const watchSupervisoryAuthorityCountry = useWatch({ name: 'supervisoryAuthorityCountry', control });
  let isEUandEEA = false;
  if(watchSupervisoryAuthorityCountry) {
    isEUandEEA = isEUandEEACountryCodes.has(watchSupervisoryAuthorityCountry.code);
  }

  React.useEffect(() => {
    if(watchSupervisoryAuthorityCountry) {
      const codeCountry = watchSupervisoryAuthorityCountry.code;
      const isEUandEEA = isEUandEEACountryCodes.has(codeCountry);
      if (supervisoryAuthority[codeCountry]) {
        const supervisoryAuthorityInfo = supervisoryAuthority[codeCountry];
        setValue('supervisoryAuthorityName', supervisoryAuthorityInfo.authority);
        setValue('supervisoryAuthorityLink', supervisoryAuthorityInfo.link);
      } else {
        setValue('supervisoryAuthorityName', '');
        setValue('supervisoryAuthorityLink', '');
      }
      setValue('supervisoryAuthorityCountryEUandEEA', isEUandEEA);
    }
  }, [watchSupervisoryAuthorityCountry]);

  return (
    <React.Fragment>
      <div className='mt-3'>
        <label className='form-label required'>Select country</label>
        <Select
          isRequired
          labelText='Country'
          name='supervisoryAuthorityCountry'
          options={options}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option}
          getOptionEqual={(option) => option.code}
        />
        <ErrorMessage
          errors={errors}
          name='thirdPartyCountries'
          render={({ message }) => (
            <small className='text-danger'>
              {message}
            </small>
          )}
        />
      </div>
      {isEUandEEA && (
        <React.Fragment>
          <div className='mt-3'>
            <Input
              isRequired
              labelText='Indicate national authority responsible for personal data protection'
              name='supervisoryAuthorityName'
              type='text'
            />
          </div>
          <div className='mt-3'>
            <Input
              isRequired
              labelText='Link for submitting complaints or obtaining information about the complaints-handling procedure'
              name='supervisoryAuthorityLink'
              type='text'
            />
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default SupervisoryAuthority